import React from "react";
import HelpContainer from "../../modules/Help/containers/HelpContainer/HelpContainer";

const Help = () => {
  return (
    <HelpContainer />
  );
};

export default Help;
